module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_2_2_2.e220e6c1.png";